"use strict";

define('components/transaction_instance',["components/dom_setup", "components/utils"], function (
  domSetup,
  utils
) {
  var transactionInstance = {
    updateDefaultedCheckbox: function () {
      var $parent = $(this).closest(".capital-call-edit");
      var contributedSum = 0;
      var contributedValueEntered = false;
      var currency = $parent
        .find('input[name="amount_received"]')
        .data("currency");
      $parent.find('input[name="amount_received"]').each(function () {
        if ($(this).val() != "") {
          contributedValueEntered = true;
        }
        contributedSum += utils.parseCurrency($(this).val(), currency);
      });

      var calledSum = 0;

      $parent.find('input[name="amount_called"]').each(function () {
        calledSum += utils.parseCurrency($(this).val(), currency);
      });

      var defaultedCheckBox = $parent.find('input[name="has_defaulted"]');
      if (calledSum > 0 && contributedSum >= calledSum) {
        defaultedCheckBox.prop("checked", false);
        defaultedCheckBox.attr("disabled", true);
      } else {
        defaultedCheckBox.attr("disabled", false);
      }

      if (contributedValueEntered && calledSum > 0 && contributedSum == 0) {
        defaultedCheckBox.prop("checked", true);
      }
    },
    bindUpdateCheckbox: function (node) {
      node.on("jsq:sequenceItemRemoved", function (event, beforeSequenceItem) {
        transactionInstance.updateDefaultedCheckbox.bind(beforeSequenceItem)();
      });

      node
        .find('input[name="amount_received"]')
        .change(this.updateDefaultedCheckbox);
      node
        .find('input[name="amount_called"]')
        .change(this.updateDefaultedCheckbox);
    },
    init: function (node) {
      domSetup.init(node);

      node.on("change", function (e) {
        if ($(e.target).is("select.cc-detail-allocation-type")) {
          var selectedOption = $(e.target).find("option:selected");
          var recallableOption = $(e.target)
            .closest(".form-group")
            .find(".recallable");
          var recallableElementsOption = $(e.target)
            .closest(".form-group")
            .find(".recallable-elements");
          var recallableSpecifyOption = $(e.target)
            .closest(".form-group")
            .find(".yes-no-recallable");
          if (selectedOption.data("affects-commitment") == 1) {
            recallableSpecifyOption.attr("disabled", false);
          } else {
            recallableSpecifyOption.attr("disabled", true);
            recallableOption.val("");
            recallableElementsOption.addClass(" hidden");
            recallableSpecifyOption.val("No");
          }
        }
      });

      node.on("change", function (e) {
        if ($(e.target).is("select.yes-no-recallable")) {
          var selectedOption = $(e.target).find("option:selected");
          var recallableElementsOption = $(e.target)
            .closest(".form-group")
            .find(".recallable-elements");
          if (selectedOption.val() == "Yes") {
            recallableElementsOption.removeClass(" hidden");
          } else {
            var recallableOption = $(e.target)
              .closest(".form-group")
              .find(".recallable");
            recallableOption.val("");
            recallableElementsOption.addClass(" hidden");
          }
        }
      });

      // Handler for the change event of distribution type selector
      node.on("change", function (e) {
        if ($(e.target).is("select.distribution-type")) {
          var selectedOption = $(e.target).find("option:selected");
          var recallableOption = $(e.target)
            .closest(".form-group")
            .find(".recallable");
          if (selectedOption.data("can-have-recallable") == "True") {
            recallableOption.removeClass("hidden");
          } else {
            recallableOption.addClass("hidden");
          }
        } else if ($(e.target).is('select[name="payment_method"]')) {
          var descInput = $(e.target)
            .closest(".contribution-data")
            .find('input[name="description"]');
          if (descInput && (!descInput.val() || !descInput.val().trim())) {
            var optionName = $(e.target)
              .find("option:selected")
              .val()
              .toLowerCase();
            descInput.attr(
              "placeholder",
              descInput.data(optionName + "-placeholder")
            );
          }
        }
      });

      node.on("change", function (e) {
        if ($(e.target).is("select.cap-activity-recalled-select")) {
          var selectedOption = $(e.target).find("option:selected");
          var recalledOption = $(e.target)
            .closest(".form-group")
            .find(".recalled");
          var recalledElementsOption = $(e.target)
            .closest(".form-group")
            .find(".recalled-elements");
          if (selectedOption.val() == 0) {
            recalledElementsOption.removeClass(" hidden");
          } else {
            recalledOption.val("");
            recalledElementsOption.addClass(" hidden");
          }
        }
      });

      node.on("change", function (e) {
        if ($(e.target).is("select.capital-activity-allocation-type")) {
          var selectedOption = $(e.target).find("option:selected");
          var recalledOption = $(e.target)
            .closest(".form-group")
            .find(".recalled");
          var recalledSpecifyOption = $(e.target)
            .closest(".form-group")
            .find(".cap-activity-recalled-select");
          if (selectedOption.data("set-to-disable") == 1) {
            var recalledElementsOption = $(e.target)
              .closest(".form-group")
              .find(".recalled-elements");
            recalledOption.val("");
            recalledSpecifyOption.val(1);
            recalledSpecifyOption.attr("disabled", true);
            recalledOption.attr("disabled", true);
            recalledElementsOption.addClass(" hidden");
          } else {
            recalledSpecifyOption.attr("disabled", false);
            recalledOption.attr("disabled", false);
          }
        }
      });

      // Handler for the 'click to reveal contribution details form' link
      node.on("click", function (e) {
        if ($(e.target).is("a.show-contribution-description")) {
          var contributionDesc = $(e.target)
            .closest(".form-group")
            .find(".contribution-description");
          contributionDesc.removeClass("hidden");

          $(e.target).parent().addClass("hidden");
        }
      });

      // Must be bound to the radio button before calling
      var hideOrShowAllocations = function () {
        var allocationList = $(this)
          .parents(".contribution-edit")
          .find(".allocation_list");
        if ($(this).val() === "Yes") {
          allocationList.find(".form-seq-add-container").hide();
          allocationList.find(".deform-seq-item").each(function (i) {
            if (i === 0) {
              $(this).find('select[name="allocation_type_id"]').val(0);
              $(this).find(".allocation-type").addClass("hidden");
              $(this).find(".allocation-type-with-recalled").addClass("hidden");
              $(this).find(".cap-activity-recalled-select").val(1);
              $(this).find(".recalled").val("");
              $(this).find(".recalled-selector").addClass("hidden");
              $(this).find(".recalled-elements").addClass("hidden");
              if (
                $(this)
                  .find('select[name="allocation_type_id"]')
                  .find("option:selected")
                  .data("set-to-disable") == 1
              ) {
                $(this)
                  .find(".cap-activity-recalled-select")
                  .attr("disabled", true);
                $(this).find(".recalled").attr("disabled", true);
              } else {
                $(this)
                  .find(".cap-activity-recalled-select")
                  .attr("disabled", false);
                $(this).find(".recalled").attr("disabled", false);
              }
              $(this).find(".recalled-label").addClass("hidden");
            } else if (i > 0) {
              $(this).remove();
            }
          });
        } else {
          allocationList.find(".form-seq-add-container").show();
          allocationList.find(".allocation-type").removeClass("hidden");
          allocationList
            .find(".allocation-type-with-recalled")
            .removeClass("hidden");
          allocationList.find(".recalled-selector").removeClass("hidden");
          allocationList.find(".recalled-label").removeClass("hidden");
        }
      };

      $('input[name="full_redemption"]').on("change", function() {
        var parentForm = $(this).closest("form");
        if ($(this).is(':checked')) {
          parentForm.find(".allocation_list .deform-seq-item").each(function (index, element) {
            if (index != 0) {
              $(element).find(".close").click();
            }
          })
          parentForm.find('input[name="amount_received"]').val("").prop("disabled", true);
          parentForm.find('.deform-seq-add').hide();
        } else {
          parentForm.find('input[name="amount_received"]').prop("disabled", false);
          parentForm.find('.deform-seq-add').show();
        }
      });

      $('input[name="is_capital_call"]').change(hideOrShowAllocations);

      $('input[name="price_per_unit"]').change(function () {
        var pricePerUnit = $(this).val();
        if ($.type(pricePerUnit) === "string") {
          pricePerUnit = parseFloat(pricePerUnit.replace(/,/g, ""));
        }

        var currency = $(this).data("currency");
        var redeemableAmount = $(this).data("redeemable-amount");
        if ($.type(redeemableAmount) === "string") {
          redeemableAmount = parseFloat(redeemableAmount.replace(/,/g, ""));
        }
        var positionBalance = 0;

        var editOwnershipForm = $(this).parents(".edit_ownership_equity_form");
        var redeemableLots = editOwnershipForm.find(".redeemable_lot_desc");

        redeemableLots.each(function () {
          var unitsAvailable = $(this)
            .siblings('input[name="lot_shares_available"]')
            .val();
          var lotAmountAvailable = unitsAvailable * pricePerUnit;
          positionBalance += lotAmountAvailable;
          $(this)
            .find(".lot_amount_available")
            .text(utils.formatCurrency(lotAmountAvailable, currency));
          $(this)
            .siblings('input[name="lot_amount_available"]')
            .val(lotAmountAvailable);
          if (redeemableAmount > 0) {
            if (lotAmountAvailable >= redeemableAmount) {
              $(this)
                .next()
                .find('input[name="amount_to_subtract"]')
                .val(redeemableAmount.toFixed(2));
              redeemableAmount = 0;
            } else {
              var amountToRedeem = +lotAmountAvailable;
              $(this)
                .next()
                .find('input[name="amount_to_subtract"]')
                .val(amountToRedeem.toFixed(2));
              redeemableAmount -= amountToRedeem;
            }
          } else {
            $(this).next().find('input[name="amount_to_subtract"]').val("");
          }
        });

        editOwnershipForm
          .find(".position_balance")
          .text(utils.formatCurrency(positionBalance, currency));
        editOwnershipForm.find(".redemption-amount-mismatch-warning").hide();

        var unitCount = editOwnershipForm.find(".unit_count");
        var precisionPortal = unitCount.data("precision-portal"),
          precisionAccounting = unitCount.data("precision-accounting"),
          unitCountText;
        if (pricePerUnit && $(this).data("redeemable-amount")) {
          unitCountText = (
            $(this).data("redeemable-amount") / pricePerUnit
          ).toFixed(precisionAccounting);
          unitCount.text(parseFloat(unitCountText).toFixed(precisionPortal));
        }

        // if, after going through the lots above, there's still an amount left to redeem,
        // that means there isn't enough available balance at the given unit price
        if (
          redeemableAmount >= 0.01 &&
          $(this).data("sign-effect") === "Negative"
        ) {
          var errorMsg = $(this).data("insufficient-funds-message");
          editOwnershipForm.find(".error-msg").text(errorMsg);
          editOwnershipForm.find(".alert-danger").show();
        } else {
          editOwnershipForm.find(".error-msg").text("");
          editOwnershipForm.find(".alert-danger").hide();
        }
      });

      var positionSelector = node.find('.select2[name="position_id"]');
      var positionData = positionSelector.select2("data");
      if (positionData && positionData.calculation_method === "unit") {
        $('input[name="price_per_unit"]').change();
      }

      $(".contribution-edit").each(function (i, el) {
        $(this)
          .find(".allocation_list .deform-seq-item")
          .first()
          .find(".col-seq-close")
          .addClass("hidden");
      });

      this.bindUpdateCheckbox(node);
      node.on("jsq:sequenceItemCreated", function (event, sequenceItem) {
        transactionInstance.bindUpdateCheckbox(sequenceItem);
      });

      var saveButton = node.find(".part-1-save");
      var originalSaveText = saveButton.text();
      var updateSaveText = function () {
        var positionData = positionSelector.select2("data");
        var isNegative = saveButton.data("sign-effect") === "Negative";
        if (positionData && positionData.calculation_method === "unit") {
          saveButton.text("Calculate " + positionData.unit_name);
        } else if (
          isNegative &&
          positionData &&
          positionData.calculation_method === "contribution"
        ) {
          saveButton.text("Continue");
        } else {
          saveButton.text(originalSaveText);
        }
      };
      updateSaveText();
      var fullRedemptionCheckbox = node.find(".full_redemption");
      var showOrHideFullRedemption = function () {
        var positionData = positionSelector.select2("data");
        var isNegative = saveButton.data("sign-effect") === "Negative";
        if (isNegative && positionData && (positionData.calculation_method === "unit" || positionData.calculation_method === "contribution")) {
          fullRedemptionCheckbox.removeClass("hidden");
        } else {
          fullRedemptionCheckbox.addClass("hidden");
        }
      };
      positionSelector.on("change", updateSaveText);
      positionSelector.on("change", showOrHideFullRedemption);
    },
  };

  return transactionInstance;
});

